<template>
    <div class="table-header-wrap">
        <div class="caption">
            <div class="w-50">
                <span class="label">
                  {{ isPatternView
                    ? $t('generic.pattern')
                    : $t('generic.phrase') }}
                </span>
            </div>

            <div class="w-50">
                <span class="label">
                  {{ $t('table.table_header.response') }}
                </span>
            </div>
        </div>

        <transition name="fade">
            <div
                v-if="isContextForm"
                class="context"
            >
                <context
                    :isPatternView="isPatternView"
                    :new-context="true"
                />
            </div>
        </transition>
    </div>
</template>

<script>
import KnowledgeBus from '@/KnowledgeBus'
import context from '@/components/common/context/context'

export default {
  components: {
    context
  },

  created () {
    KnowledgeBus.$on('context-form::show', this.showContextForm)
    KnowledgeBus.$on('context-form::hide', this.hideContextForm)
  },

  beforeDestroy () {
    KnowledgeBus.$off('context-form::show', this.showContextForm)
    KnowledgeBus.$off('context-form::hide', this.hideContextForm)
  },

  data () {
    return {
      isContextForm: false,
      showConfirms: false
    }
  },

  methods: {
    showContextForm () {
      this.isContextForm = true
    },

    hideContextForm () {
      this.isContextForm = false
    }
  },

  props: {
    isPatternView: Boolean
  }
}
</script>

<style lang="scss" scoped>
    .fade-enter-active, .fade-leave-active {
        transition: all .5s;
    }

    .fade-enter {
        opacity: 0;
    }

    .table-header-wrap {
        display: flex;
        flex-direction: column;
        z-index: 2;

        .caption {
            display: flex;
            height: 32px;
            align-items: center;
            background-color: $or-grey;
            border-top-right-radius: 4px;
            border-top-left-radius: 4px;

            .w-50 {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 50%;
                padding-left: $sp-2;
                height: 32px;

                .label {
                    display: flex;
                    flex-grow: 1;
                    font-size: 14px;
                    font-weight: bold;
                    color: $or-black-blue;
                    justify-content: left;
                }
            }
        }

        .header-row {
            display: flex;
            flex-grow: 1;
            align-items: center;
            background-color: $or-grey;

            &.context {
                width: 100%;
                z-index: 4;
            }

            &:first-of-type {
                justify-content: flex-end;
            }

            .w-50 {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 50%;
                padding-left: $sp-2;

                .add-context-btn {
                    border: none;
                }
            }
        }
    }
</style>
